<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import EuroSmart from "@components/invoice_control/euro_smart.vue";
import SmartCart from "@components/invoice_control/smart_cart.vue";
const _ = require("lodash");

export default {
  page: {
    title: "Invoice Control",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    EuroSmart,
    SmartCart,
  },
  data() {
    return {
      title: "Invoice Control",
      showDetail: false,
      toDetail: {},
      breadCrumb: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Invoice Control",
          active: true,
        },
      ],

      hover: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadCrumb" />
    <b-card no-body class="p-2">
      <b-tabs lazy content-class="mb-0 pt-0">
        <b-tab active>
          <template #title>
            <i class="fad fa-megaphone font-20"></i>
            {{ $t("Facturas EuroSmart") }}
          </template>
          <EuroSmart></EuroSmart>
        </b-tab>
        <b-tab>
          <template #title>
            <i class="fad fa-megaphone font-20"></i>
            Facturas SmartCart
          </template>
          <SmartCart></SmartCart>
        </b-tab>
      </b-tabs>
    </b-card>
    <!-- Detail modal -->
  </Layout>
</template>

<style lang="scss"></style>
